import { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { useAppContext } from '../../AppContext';
import mainAxios from '../../services/mainAxios';


const useSettingsCompany = () => {
  const location = useLocation();
  const {
    company: [currentCompany, setCurrentCompany],
    user: [user],
    selectedCompany: [selectedCompany],
  } = useAppContext();

  const searchParams = new URLSearchParams(location.search);
  const companyIdParam = searchParams.get('companyId');

  const [managedCompany, setManagedCompany] = useState(null);
  const [loading, setLoading] = useState(false);

  const isAdminMode = !!companyIdParam;

  useEffect(() => {
    if (companyIdParam) {
      if (currentCompany?.id == companyIdParam) {
        setManagedCompany(currentCompany);
        setLoading(false);
      } else {
        setLoading(true);
        mainAxios
          .post('apiEndpoint/search', {
            object: 'GetCompany',
            value: '',
            params: {
              id: companyIdParam,
            },
          })
          .then((res) => {
            if (res.data.status && res.data.content?.length > 0) {
              setManagedCompany(res.data.content[0]);
            }
            setLoading(false);
          })
          .catch(() => {
            setLoading(false);
          });
      }
    } else {
      setManagedCompany(null);
      setLoading(false);
    }
  }, [companyIdParam, currentCompany?.id]);

  const company = isAdminMode ? managedCompany : currentCompany;

  const setCompany = isAdminMode ? setManagedCompany : setCurrentCompany;

  const getCompany = ({ reload = false } = {}) => {
    const targetId = isAdminMode ? companyIdParam : currentCompany?.id;
    if (!targetId || !reload) return;

    mainAxios
      .post('apiEndpoint/search', {
        object: 'GetCompany',
        value: '',
        params: {
          id: String(targetId),
        },
      })
      .then((res) => {
        if (res.data.status && res.data.content?.length > 0) {
          if (isAdminMode) {
            setManagedCompany(res.data.content[0]);
          } else {
            setCurrentCompany(res.data.content[0]);
          }
        }
      });
  };

  // Build the back link URL (preserves companyId if in admin mode)
  const getBackUrl = () => {
    if (isAdminMode) {
      return `/settings?companyId=${companyIdParam}`;
    }
    return '/settings';
  };

  return {
    company,
    setCompany,
    getCompany,
    loading,
    isAdminMode,
    companyIdParam,
    getBackUrl,
    user,
    selectedCompany,
  };
};

export default useSettingsCompany;
